import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import Logo from './Logo';

// Icônes SVG
const FacebookIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

export default function Footer() {
  const { t, i18n } = useTranslation();

  return (
    <footer className={`${i18n.language === 'ar' ? 'rtl' : ''} bg-gradient-to-r from-primary-900 to-primary-600 text-white pt-16 pb-8`}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div>
            <Link to="/" className="mb-6 block">
              <Logo className="h-12" />
            </Link>
            <p className="text-blue-100 mb-4">{t('footer_description')}</p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/profile.php?id=61581459598038" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-accent-500 transition cursor-pointer">
                <FacebookIcon />
              </a>
              <a href="https://wa.me/23598222110" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-accent-500 transition cursor-pointer">
                <WhatsAppIcon />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-display font-bold text-lg mb-4 text-accent-400">{t('quick_links')}</h3>
            <ul className="space-y-2">
              <li><Link to="/destinations" className="text-blue-100 hover:text-white transition">{t('nav_destinations')}</Link></li>
              <li><Link to="/schedule" className="text-blue-100 hover:text-white transition">{t('nav_schedule')}</Link></li>
              <li><Link to="/booking" className="text-blue-100 hover:text-white transition">{t('nav_booking')}</Link></li>
              <li><Link to="/suggestion" className="text-blue-100 hover:text-white transition">💡 Suggestions</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-display font-bold text-lg mb-4 text-accent-400">{t('information')}</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-blue-100 hover:text-white transition">{t('nav_about')}</Link></li>
              <li><Link to="/contact" className="text-blue-100 hover:text-white transition">{t('nav_contact')}</Link></li>
              <li><Link to="/legal" className="text-blue-100 hover:text-white transition">{t('nav_legal')}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-display font-bold text-lg mb-4 text-accent-400">{t('contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <span className="text-accent-400">📱</span> +235 64 64 51 51
              </li>
              <li className="flex items-center gap-3">
                <span className="text-accent-400">📧</span> contact@expressabouhamama.td
              </li>
              <li className="flex items-center gap-3">
                <span className="text-accent-400">📍</span> {t('agency_address')}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-6 text-center text-blue-200">
          <p>© 2025 {t('bus_company')}. {t('all_rights_reserved')}</p>
        </div>
      </div>
    </footer>
  );
}